import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentModule} from 'app/component/component.module';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {Chain20Component} from 'app/tool-layer/tools/chain-20/chain-20.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [Chain20Component],
    entryComponents: [Chain20Component],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(Chain20Component),
            multi: true,
        },
    ],
})
export class Chain20Module {}
